import React from 'react';
import './SuperAdminStyles.css';

const UserRoles = () => {
  return (
    <div className="user-roles">
      <h2>User Roles & Permissions</h2>
      <div className="roles-container">
        <div className="roles-card">
          <h3>Role Management</h3>
          <p>Create and manage user roles with specific permissions.</p>
        </div>
        <div className="roles-card">
          <h3>Permission Matrix</h3>
          <p>View and edit permission assignments for each role.</p>
        </div>
        <div className="roles-card">
          <h3>User Assignment</h3>
          <p>Assign roles to users and manage access levels.</p>
        </div>
      </div>
    </div>
  );
};

export default UserRoles;
